import { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';

import LogoutButton from './LogoutButton';
import { Divider } from '@mui/material';
import { Link } from 'react-router-dom';

export default function UserNav(props) {
  const [anchorElUser, setAnchorElUser] = useState(null);
  const settings = ['Scenarios'] // ['Account', 'Invoices', 'Settings'];
  const [username, setUsername] = useState()

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  useEffect(() => {
    setUsername(localStorage.getItem('username'))
  }, [])

  return (
    <Box sx={{ ml: 1 }}>
      {/* <Tooltip title="Open settings"> */}
      <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
        <Avatar alt="Remy Sharp" src="" />
      </IconButton>
      {/* </Tooltip> */}
      <Menu
        sx={{ mt: '45px' }}
        id="menu-appbar"
        anchorEl={anchorElUser}
        // dense
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        keepMounted
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={Boolean(anchorElUser)}
        onClose={handleCloseUserMenu}
        PaperProps={{
          elevation: 0,
          sx: {
            boxShadow: 1,
            bgcolor: "grey.light",
            overflow: 'visible',
            // filter: 'drop-shadow(0px 0px 0px rgba(0,0,0,0.32))',
            mt: 1.5,
            '& .MuiAvatar-root': {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            '&:before': {
              content: '""',
              display: 'block',
              position: 'absolute',
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: 'grey.light',
              transform: 'translateY(-50%) rotate(45deg)',
              zIndex: 0,
            },
          },
        }}
      >
        {settings.map((setting, index) => (
          <MenuItem key={setting} onClick={handleCloseUserMenu}>
            <Link to={"/" + setting} {...props} style={{ textDecoration: 'none', color: "black" }}>
              <Typography textAlign="center">{setting}</Typography>
            </Link>
          </MenuItem>
        ))}
        <Divider />
        <Box sx={{ textAlign: "left", padding: "0.5rem 1rem 0.5rem 1rem" }}>
          <Typography variant="body2" color="grey.main" sx={{ paddingBottom: ".5rem" }}>{username}</Typography>
          <LogoutButton {...props} />
        </Box>
      </Menu>
    </Box>
  )
}